module.exports = {
    EVENT_GET: 'EVENT_GET',
    EVENTS_GET: 'EVENTS_GET',
};
